module.exports = __webpack_public_path__ + "media/chat_2.009450f5.mp3";